module.exports = __webpack_public_path__ + "static/media/duraplast.8add65ac.png";